// import Vue from 'vue'
import { BOOKMAKER_SOURCE_LOOKUP } from '../common/constants'
import {
  subscribePrices,
  subscribeRaceUpdates
} from '../common/queries'
import gql from 'graphql-tag'
import { apolloClient } from '../vue-apollo'
import { format, formatISO } from 'date-fns'
import axios from 'axios'
const merge = require('lodash.merge')

/** type definition of clientVisibility type, used to allow parent windows let us know if our iframe is visible or hidden
 * @typedef {'open'|'close'} clientVisibilityType
 * */

let bookieCount = 0

const store = {
  state: {
    gbsID: '',
    raceNo: '',
    raceID: '',
    runnerNo: '',
    raceSource: 'gbs',
    bookie: window.location.host.split('.')[0],
    priceType: 'WIN_FIXED_ODDS',
    source: BOOKMAKER_SOURCE_LOOKUP[window.location.host.split('.')[0]],
    sources: 'V',
    sourceTypes: {
      source: BOOKMAKER_SOURCE_LOOKUP[window.location.host.split('.')[0]],
      type: 'WIN_FIXED_ODDS'
    },
    htmlFragments: [],
    detailedRace: {},
    runnerList: {},
    singleRunner: {},
    defaultBestPriceBookies: [
      'BB4',
      'BT',
      'SB2',
      'TS2',
      'TS_V',
      'TS_N',
      'TS_Q',
      'BD2',
      'LB2',
      'ND',
      'UB',
      'CB2',
      'BB2',
      'SB5',
      'DD'
    ],
    bestPriceBookies: [],
    bestPriceBookiesArrays: [],
    bestOddsArray: [],
    /**
     * this allows parent windows to tell us if iframe is visible or currently hidden
     *  @type {clientVisibilityType}
     * */
    clientVisibility: 'open'
  },
  mutations: {
    setRouterVariables (state, obj) {
      state.gbsID = obj.gbsID
      state.raceNo = obj.raceNo
      state.runnerNo = obj.runnerNo
    },
    setBestPriceBookies (state, arr) {
      state.bestPriceBookies = arr
    },
    setRaceID (state, id) {
      state.raceID = id
    },
    /**
     * @param state
     * @param {clientVisibilityType} arr
    */
    setClientVisibility (state, arr) {
      state.clientVisibility = arr
    },
    updateBestBookie (state, arr) {
      state.bestOddsArray = arr
    },
    updateDetailedRace (state, race) {
      state.detailedRace = race
    },
    updateRunnerList (state, runnerList) {
      state.runnerList = runnerList
    },
    updateSingleRunner (state, runner) {
      state.singleRunner = runner
    },
    updateArrayOfBookies (state, arr) {
      state.bestPriceBookiesArrays = arr
    },
    updateHtmlFragments (state, arr) {
      state.htmlFragments = arr
    }
  },
  actions: {
    setRouterVariables (context, obj) {
      context.commit('setRouterVariables', obj)
    },
    setBestPriceBookies (context, arr) {
      context.commit('setBestPriceBookies', arr)
    },
    setRaceID (context, id) {
      context.commit('setRaceID', id)
    },
    /**
     * @param context
     * @param {clientVisibilityType} value
    */
    setClientVisibility (context, value) {
      context.commit('setClientVisibility', value)
    },
    async fetchShortForm (context) {
      const auth = '02bdd529d4d3407aa033f8da4b383cf5'
      const params = {
        source: 'gbs',
        raceNumber: context.state.raceNo,
        meetingId: context.state.gbsID
      }
      try {
        const { data } = await axios.get(
          'http://localhost:8084/shortformRendered',
          {
            params,
            headers: { Authorization: `Bearer ${auth}` }
          }
        )
        context.commit('updateHtmlFragments', data.renderedForm)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchRace (context) {
      const auth = '02bdd529d4d3407aa033f8da4b383cf5'
      const sourceId = context.state.gbsID
      const raceNo = context.state.raceNo
      const source = context.state.source
      const params = {
        bookie: source,
        raceNo: raceNo,
        gbsId: sourceId
      }
      try {
        const newResult = await axios.get(
          `${process.env.VUE_APP_SHORTFORM_URL}formGuide`,
          {
            params,
            headers: { Authorization: `Bearer ${auth}`, FormRequestLocation: window.location.host }
          })
        const race = newResult.data.race
        context.commit('updateDetailedRace', race)
        document.title = `Form Guide - ${race.meeting.track.name} ${
          race.number
        } - ${format(new Date(race.startTime), 'dd MMM yyyy')}`
        context.commit('setRaceID', race.id)
        await context.dispatch('subscribePrices')
        // await context.dispatch('subscribeRaceUpdates')
        if (window.location.host.split('.')[0] === 'do') {
          await context.state.defaultBestPriceBookies.forEach(b => {
            context.dispatch('fetchFlucs', b)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSpeedMap (context) {
      const auth = '02bdd529d4d3407aa033f8da4b383cf5'
      const sourceId = context.state.gbsID
      const raceNo = context.state.raceNo
      const params = {
        raceNo: raceNo,
        gbsId: sourceId
      }
      try {
        const newResult = await axios.get(
          `${process.env.VUE_APP_SHORTFORM_URL}speedMap`,
          {
            params,
            headers: { Authorization: `Bearer ${auth}`, FormRequestLocation: window.location.host }
          })
        const race = newResult.data.race
        context.commit('updateDetailedRace', race)
        document.title = `Form Guide - ${race.meeting.track.name} ${race.number} - ${format(new Date(race.startTime), 'dd MMM yyyy')}`
        context.commit('setRaceID', race.id)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchSingleRunner (context) {
      const auth = '02bdd529d4d3407aa033f8da4b383cf5'
      const raceSource = 'gbs'
      const sourceId = context.state.gbsID
      const raceNo = context.state.raceNo
      const runnerNo = context.state.runnerNo
      const params = {
        source: raceSource,
        raceNumber: raceNo,
        meetingId: sourceId,
        runnerNumber: runnerNo
      }
      try {
        const newResult = await axios.get(
          `${process.env.VUE_APP_SHORTFORM_URL}shortform/`,
          {
            params,
            headers: { Authorization: `Bearer ${auth}`, FormRequestLocation: window.location.host }
          })
        const singleRunner = newResult.data
        context.commit('updateSingleRunner', singleRunner)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFlucs (context, b) {
      const auth = '02bdd529d4d3407aa033f8da4b383cf5'
      const raceID = context.state.raceID
      const source = b
      const params = {
        raceId: raceID,
        bookie: b
      }
      try {
        const newResult = await axios.get(
          `${process.env.VUE_APP_SHORTFORM_URL}getFlucs`,
          {
            params,
            headers: { Authorization: `Bearer ${auth}`, FormRequestLocation: window.location.host }
          }
        )
        bookieCount += 1
        const flucs = {
          source: source,
          competitors: newResult.data.race.competitors
        }
        context.state.bestPriceBookiesArrays.push(flucs)
        if (bookieCount === context.state.defaultBestPriceBookies.length) {
          await context.dispatch('mutateFlucs')
        }
      } catch (error) {
        console.log(error)
      }
    },
    async mutateFlucs (context) {
      const bookieArr = context.state.bestPriceBookiesArrays
      const finalBookieArr = []
      const allCompetitors = []
      bookieArr.forEach(d => {
        const compArr = []
        d.competitors.forEach(c => {
          const flucs = c.flucs
          if (flucs.length > 0) {
            const compObj = {
              price: flucs[flucs.length - 1].price,
              time: flucs[flucs.length - 1].time,
              tabNo: flucs[flucs.length - 1].tabNo,
              source: d.source
            }
            compArr.push(compObj)
            allCompetitors.push(flucs[flucs.length - 1].tabNo)
          }
        })
        finalBookieArr.push(compArr)
      })
      finalBookieArr.filter(a => a.length >= 1)
      const uniqueComps = [...new Set(allCompetitors)]
      const bestPriceArrComp = []
      uniqueComps.forEach(b => {
        const bestPriceArr = []
        if (finalBookieArr.length >= 1) {
          // eslint-disable-next-line array-callback-return
          finalBookieArr.map(f => {
            const price = f.find(r => r.tabNo === b)
            if (price) {
              bestPriceArr.push(price)
            }
          })
        }
        const maximum = bestPriceArr.reduce((acc, i) =>
          i.price > acc.price ? i : acc
        )
        bestPriceArrComp.push(maximum)
      })
      context.commit('updateBestBookie', bestPriceArrComp)
    },
    async subscribeRaceUpdates (context) {
      const raceID = context.state.raceID
      const query = subscribeRaceUpdates()
      const result = await apolloClient.subscribe({
        query: gql`
          ${query}
        `,
        variables: { raceID }
      })
      result.subscribe({
        next (data) {
          const race = context.state.detailedRace
          // console.log(race, 'state for race obj')
          const raceUpdate = data.data.raceUpdated
          const newDetailedRace = merge(race, raceUpdate)
          // console.log(newDetailedRace, 'race update new state race')
          context.commit('updateDetailedRace', newDetailedRace)
        }
      })
    },
    async subscribePrices (context) {
      const raceID = context.state.raceID
      const sourceTypes = []
      if (window.location.host.split('.')[0] === 'do') {
        context.state.defaultBestPriceBookies.forEach(b => {
          const obj = {
            source: b,
            type: 'WIN_FIXED_ODDS'
          }
          sourceTypes.push(obj)
        })
      } else {
        sourceTypes.push(context.state.sourceTypes)
      }
      const query = subscribePrices()
        .replace(/"(\w+)"\s*:/g, '$1:')
        .replace(/['"]+(WIN)/g, 'WIN')
        .replace(/(WIN)+['"]/g, 'WIN')
        .replace(/['"]+(PLACE)/g, 'PLACE')
        .replace(/(PLACE)+['"]/g, 'PLACE')
        .replace(/(ODDS)+['"]/g, 'ODDS')
      const result = await apolloClient.subscribe({
        query: gql`${query}`,
        variables: { raceID, sourceTypes }
      })
      result.subscribe({
        next (data) {
          if (window.location.host.split('.')[0] === 'do') {
            // const blah = arrayOfBookies
            const arrayOfBookies = context.state.bestPriceBookiesArrays
            // const prices = prices from subscription
            const prices = data?.data?.priceUpdates?.prices
            // get source from sub and find array in arrayOfBookies that corresponds
            const priceSource = prices[0].source
            // loop that array and push the prices into the flucs
            arrayOfBookies.forEach(k => {
              if (priceSource === k.source) {
                k?.competitors?.forEach(c => {
                  const tabNo = c.flucs[0]?.tabNo
                  const price = prices.find(
                    p => p.tabNo === tabNo && p.type === 'WIN_FIXED_ODDS'
                  )
                  if (price) {
                    price.time = formatISO(Date.now())
                    c.prices = [price]
                    c.flucs.push(price)
                  }
                })
              }
            })
            // update arrayOfBookies with blah
            context.commit('updateArrayOfBookies', arrayOfBookies)
            context.dispatch('mutateFlucs')
          } else {
            const race = context.state.detailedRace
            const prices = data?.data?.priceUpdates?.prices
            // console.log(race, 'state race in price update')
            race?.competitors?.forEach(c => {
              const price = prices.find(
                p => p.tabNo === c.tabNo && p.type === 'WIN_FIXED_ODDS'
              )
              if (price) {
                price.time = formatISO(Date.now())
                c.prices = [price]
                c.flucs.push(price)
              }
            })
            context.commit('updateDetailedRace', race)
          }
        },
        error (error) {
          return error
        }
      })
    }

  },
  getters: {
    hasFeature (state) {
      return function (feature) {
        const features = process.env.VUE_APP_FEATURE_FLAGS?.split?.(',')
        return features?.some?.(x => x.trim() === feature.trim())
      }
    },
    isMobile () {
      /* eslint-disable */
      let check = false
      const feature = 'mobileView'
      const features = process.env?.VUE_APP_FEATURE_FLAGS?.split?.(',')
      if (features?.some(x => x.trim() === feature.trim())) {
        ;(function(a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = true
        })(navigator.userAgent || navigator.vendor || window.opera)
      }
      return check
    }
  }
}

export default store
